export class Validar {
    public key: string;
    public id: number;
  constructor() {  }

}